import React from "react";

const ToastStack = ({ toasts = [] }) => (
  <div className="fixed right-4 top-[calc(16px+env(safe-area-inset-top,0px))] z-[4200] flex max-w-sm flex-col gap-2 sm:right-6 sm:top-[calc(24px+env(safe-area-inset-top,0px))]">
    {toasts.slice(0, 3).map((toast) => (
      <div
        key={toast.id}
        className={`rounded-xl px-4 py-3 text-sm font-semibold text-white shadow-lg animate-[toastIn_160ms_ease-out] ${
          toast.type === "success" ? "bg-emerald-600" : "bg-red-600"
        }`}
      >
        {toast.text}
      </div>
    ))}
  </div>
);

export default ToastStack;
